import { HttpHeaders, HttpClient, HttpBackend } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from '../../../tech-lib-portal.interceptor';
import { SessionService } from '../../../services/session.service';
import { LoginEnum, CommonEnum } from '../../../services/api-names';
import { Utils } from '../../../utils/utils';
import { ClientLogin } from '../request/models/client-login.model';
import { ClientDataLoginInterface } from '../request/interfaces/client-data-login.interface';
import { AppConfig } from 'projects/apps/portal-client/src/app/utils/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  HttpHeaders: HttpHeaders;

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private router: Router,
    private http: HttpClient
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
  }

  validationLoginClient(
    password: string,
    username: string
  ): Observable<ClientDataLoginInterface> {
    this.updateSession();
    var url = this.config.baseApi + LoginEnum.validation_login_client;

    const bodyRequest = new ClientLogin();
    const headers = this.HttpHeaders;
    bodyRequest.Domain = this.session.domain;
    bodyRequest.Language = this.session.language;
    bodyRequest.Password = password;
    bodyRequest.UserName = username;

    return this.http.post<ClientDataLoginInterface>(url, bodyRequest, {
      headers,
      observe: 'body',
    });
  }

  validationLoginClientRest(
    password: string,
    username: string,
    deviceid: string,
    forcelogin: boolean
  ): Observable<ClientDataLoginInterface> {
    this.updateSession();
    var url = this.config.baseApi + LoginEnum.apirest_client_login;
    const bodyRequest = new ClientLogin();
    const headers = this.HttpHeaders;
    bodyRequest.Domain = this.session.domain;
    bodyRequest.Language = this.session.language;
    bodyRequest.Password = password;
    bodyRequest.UserName = username;
    bodyRequest.DeviceId = deviceid; 
    bodyRequest.ForceLogin = forcelogin; 

    return this.http.post<ClientDataLoginInterface>(url, bodyRequest, {
      headers,
      observe: 'body',
    });
  }

  sendResetPassMailClient(
    username: string,
    domain: string,
    language: string,
    email: string
  ): Observable<any> {
    this.updateSession();
    //var url = this.config.baseApi + LoginEnum.user_sendresetpassmailclient;
    var url = Utils.formatString(
      this.config.baseApi + LoginEnum.user_sendresetpassmailclient,
      [email]
    );

    const bodyRequest =
      '{"UserName":"' +
      username +
      '",' +
      '"Domain":"' +
      domain +
      '",' +
      '"Language":"' +
      language +
      '"}';
   const httpclientNoHeaders = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('Tower30-Domain', this.config.domain);
    headers = headers.set('Tower30-Language', this.config.language);
    return httpclientNoHeaders.post<any>(url, bodyRequest, {
      headers,
      observe: 'body',
    });
  }
  sendRegisterClient (email: string): Observable<any> {
    this.updateSession();
    var url = this.config.baseApi + LoginEnum.register;
    let http = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();

    const bodyRequest = {
      Email: email,
    };
    return this.http.post<any>(url, bodyRequest, {
      headers,
      observe: 'body',
    });
  }
  validateTokenModifyPassword(token: string): Observable<any> {
    this.updateSession();
    var url =
      this.config.baseApi +
      LoginEnum.client_validatetokenmodifypassword +
      '?ta=' +
      token;
    return this.http.get<any>(url);
  }

  modifyPassword(token: string, password: string): Observable<any> {
    this.updateSession();
    let http = new HttpClient(this.httpBackend);
    let headers: HttpHeaders = new HttpHeaders();
    //headers = headers.append('Content-Type', 'multipart/form-data');
    headers = headers.append('Tower30-NewPassword', password);
    let options: any = { headers: headers };
    options.observe = 'body';

    var url = Utils.formatString(
      this.config.baseApi + LoginEnum.client_modifypassword,
      [token]
    );

    /*var url =
      this.config.baseApi +
      LoginEnum.client_modifypassword +
      '?ta=' +
      token +
      '&pwd=' +
      password;*/
    //return this.http.get<any>(url);

    const bodyRequest = '';
    return http.post<any>(url, bodyRequest, options);
  }

  activateaccount(ta: string): Observable<any> {
    this.updateSession();
    var url = Utils.formatString(
      this.config.baseApi + LoginEnum.activateaccount,
      [ta]
    );

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
